import { Link } from 'components/Link'
import { SearchableArticle } from 'features/Blog/utils/getBlogIndexPageProps'
import { AllArticlesLinksRoot } from './AllArticlesLinks.styles'

type AllArticlesLinksProps = {
  articles: SearchableArticle[]
}

export const AllArticlesLinks = ({ articles }: AllArticlesLinksProps) => {
  return (
    <AllArticlesLinksRoot>
      {articles.map((article) => (
        <li key={article.postUrl}>
          <Link href={`/blog/${article.postUrl}`}>{article.postTitle}</Link>
        </li>
      ))}
    </AllArticlesLinksRoot>
  )
}
